import { h, JSX } from "preact";

import classname from "../../../../foundation/utils/classname";
import Input, { InputProps } from "..";

import styles from "./InputWithLabel.module.css";

type InheritedLabelProps = JSX.HTMLAttributes<HTMLSpanElement>;
type LabelProps = InheritedLabelProps & {
    textClass?: string;
};

interface Props {
    class?: string;
    inputProps?: InputProps;
    labelProps?: LabelProps;
}

function InputWithLabel({
    class: cssClass,
    inputProps: { class: inputClass, ...restOfInputProps } = {},
    labelProps: { class: labelClass, textClass: labelTextClass = "body-1", ...restOfLabelProps } = {}
}: Props) {
    return (
        <div class={classname(styles.inputWithLabel, cssClass)}>
            <span
                {...restOfLabelProps}
                class={classname(styles.label, labelTextClass, labelClass)}/>
            <Input
                class={classname(styles.input, inputClass)}
                {...restOfInputProps}/>
        </div>
    );
}

export default InputWithLabel;
export { Props as InputWithLabelProps };
